module.exports = __webpack_public_path__ + "media/images/hubs-bg-ffe6a5e3c0102510b17d985e9b10a1bb.jpg";